import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {
  loadClusterInstanceTypes,
  loadClusterInstanceTypesFailure,
  loadClusterInstanceTypesSuccess
} from './organization-account.cluster-instance-types.actions';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {InstanceTypesService} from '../../../services/api/account/instance-types/instance-types.service';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';


@Injectable()
export class OrganizationAccountClusterInstanceTypesEffects {

  // noinspection JSUnusedGlobalSymbols
  loadClusterInstanceTypes$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadClusterInstanceTypes),
        concatMap((parameters: { region: RegionCode }) => {
            return this.service.getClusterInstanceTypes(parameters.region)
              .pipe(
                map((data: InstanceType[]) => loadClusterInstanceTypesSuccess({data})),
                catchError((error: any) => of(loadClusterInstanceTypesFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: InstanceTypesService
  ) {
  }

}
